function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.847 14.847h28.475v28.475H14.847Z",
    style: {
      fill: "#48489d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.424 14.847h28.474v28.475H49.424Z",
    style: {
      fill: "#6464b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.678 14.847h28.475v28.475H84.678Z",
    style: {
      fill: "#9292cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.847 49.424h28.475v28.474H14.847Z",
    style: {
      fill: "#6464b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.424 49.424h28.474v28.474H49.424Z",
    style: {
      fill: "#7a7ac2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.678 49.424h28.475v28.474H84.678Z",
    style: {
      fill: "#9494ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.847 84.678h28.475v28.475H14.847Z",
    style: {
      fill: "#9292cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.424 84.678h28.474v28.475H49.424Z",
    style: {
      fill: "#9494ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.678 84.678h28.475v28.475H84.678Z",
    style: {
      fill: "#9f9fd3"
    }
  }));
};
export default SvgIcon;